module.exports = __webpack_public_path__ + "static/media/WhiteUs.a8085da2.jpg";